import React from "react";
import MovieCard from "./MovieCard";

class MoviesList extends React.Component {
    render() {
        const {
            movies,
            favorites,
            updateFavorites,
            watchedToggle,
            watched
        } = this.props;
        return (
            <div>
                <ul className="movies">
                    {movies
                        .filter(
                            (movie, index, self) =>
                                index ===
                                self.findIndex(
                                    t =>
                                        t.id === movie.id &&
                                        movie.poster_path !== "N/A"
                                )
                        )
                        .map(movie => (
                            <MovieCard
                                movies={movies}
                                movie={movie}
                                key={movie.id}
                                toggleFavorite={updateFavorites}
                                favorites={favorites}
                                watchedToggle={watchedToggle}
                                watched={watched}
                                isBlurred={true}
                            />
                        ))}
                </ul>
            </div>
        );
    }
}

export default MoviesList;



// WEBPACK FOOTER //
// ./src/components/MoviesList.js